export const ApiEditSpace = Symbol('ApiEditSpace');
